import React from 'react';

import style from './Footer.module.scss';

const Footer = () => {
  return (<p className={style.credits}>concept: <a href="https://www.limerickeyinternational.com/" target="_blank" rel="noopener noreferrer">Lime Rickey International</a> &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; code: <a href="https://andrejhronco.com" target="_blank" rel="noopener noreferrer">Andrej Hronco</a></p>)
}

export default Footer;